export const deadlineFromRemainingSeconds = (remainingSeconds, now = Date.now()) => {
  if (remainingSeconds === null || remainingSeconds === undefined || remainingSeconds === "") {
    return null;
  }

  const seconds = Number(remainingSeconds);
  const currentTime = Number(now);
  if (!Number.isFinite(seconds) || seconds < 0 || !Number.isFinite(currentTime)) {
    return null;
  }

  return currentTime + seconds * 1000;
};

export const shouldLogoutForIdle = (authenticated, deadlineAt, now = Date.now()) => {
  if (deadlineAt === null || deadlineAt === undefined || deadlineAt === "") {
    return false;
  }
  const deadline = Number(deadlineAt);
  const currentTime = Number(now);
  return (
    Boolean(authenticated) &&
    Number.isFinite(deadline) &&
    Number.isFinite(currentTime) &&
    deadline <= currentTime
  );
};
